import { LogoSunpoint } from './LogoSunpoint'

export default LogoSunpoint
